import { render } from "./CrmDealKanbanView.vue?vue&type=template&id=61afafb5&scoped=true"
import script from "./CrmDealKanbanView.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanView.vue?vue&type=script&lang=js"

import "./CrmDealKanbanView.vue?vue&type=style&index=0&id=61afafb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61afafb5"]])

export default __exports__